import { SVGProps, Ref, forwardRef } from 'react';

export const MailBrandAltSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M10.008 7.998a2.006 2.006 0 1 1-4.012-.001 2.006 2.006 0 0 1 4.012.001M8.002 1.333a6.677 6.677 0 0 0-6.669 6.67c0 3.676 2.992 6.664 6.67 6.664a6.63 6.63 0 0 0 3.756-1.162l.02-.012-.898-1.045-.017.008a5.3 5.3 0 0 1-2.862.84 5.305 5.305 0 0 1-5.298-5.298A5.305 5.305 0 0 1 8.002 2.7 5.305 5.305 0 0 1 13.3 7.998q0 .57-.125 1.14c-.167.69-.648.899-1.011.87-.364-.03-.79-.289-.794-.924V7.998a3.376 3.376 0 0 0-3.372-3.372 3.376 3.376 0 0 0-3.372 3.372 3.376 3.376 0 0 0 3.372 3.372 3.36 3.36 0 0 0 2.39-.994c.372.576.978.94 1.667.994a2.267 2.267 0 0 0 1.534-.447c.4-.305.698-.744.86-1.27.026-.084.076-.28.076-.28v-.009c.096-.422.142-.844.142-1.366.004-3.673-2.988-6.665-6.665-6.665"
                fill="white"
            />
        </g>
    </svg>
));
MailBrandAltSize16Glyph.displayName = 'MailBrandAltSize16Glyph';
